import React, { useEffect, useRef, useState } from "react";
import { dmyToIso, formatDmy, maskDmy } from "../utils/dateFormat";

// Pengganti <input type="date">. Input tanggal bawaan browser mengikuti
// locale perangkat (sering tampil mm/dd/yyyy), jadi yang ditampilkan di sini
// field teks dd/mm/yyyy + tombol kalender. Kontraknya sama dengan input
// bawaan: `value` dan `e.target.value` di onChange tetap yyyy-mm-dd, dan ""
// selama tanggal belum lengkap/valid — backend tidak perlu diubah.
const DateInput = ({
  value,
  onChange,
  className = "form-control",
  style,
  placeholder = "dd/mm/yyyy",
  min,
  max,
  disabled,
  required,
  id,
  name,
}) => {
  const [text, setText] = useState(formatDmy(value));
  const lastEmitted = useRef(value || "");
  const pickerRef = useRef(null);

  // Sinkron saat value diubah dari luar (data profil selesai dimuat, form
  // di-reset), tapi jangan menimpa ketikan yang belum lengkap.
  useEffect(() => {
    if ((value || "") !== lastEmitted.current) {
      lastEmitted.current = value || "";
      setText(formatDmy(value));
    }
  }, [value]);

  const emit = (iso) => {
    if (iso === lastEmitted.current) return;
    lastEmitted.current = iso;
    if (onChange) onChange({ target: { value: iso, name } });
  };

  const handleType = (e) => {
    const masked = maskDmy(e.target.value);
    setText(masked);
    emit(dmyToIso(masked));
  };

  const handlePick = (e) => {
    setText(formatDmy(e.target.value));
    emit(e.target.value);
  };

  const openPicker = () => {
    const el = pickerRef.current;
    if (!el || disabled) return;
    try {
      el.showPicker();
    } catch {
      el.focus();
      el.click();
    }
  };

  const invalid = text.length === 10 && !dmyToIso(text);

  return (
    <div style={{ position: "relative" }}>
      <input
        type="text"
        inputMode="numeric"
        id={id}
        name={name}
        className={`${className}${invalid ? " is-invalid" : ""}`}
        style={{ ...style, paddingRight: "44px" }}
        placeholder={placeholder}
        value={text}
        onChange={handleType}
        disabled={disabled}
        required={required}
        maxLength={10}
        autoComplete="off"
      />
      <button
        type="button"
        onClick={openPicker}
        disabled={disabled}
        aria-label="Open calendar"
        style={{
          position: "absolute",
          top: "50%",
          right: "10px",
          transform: "translateY(-50%)",
          border: "none",
          background: "transparent",
          padding: "4px",
          lineHeight: 1,
          color: "inherit",
          cursor: disabled ? "default" : "pointer",
        }}
      >
        <i className="bi bi-calendar3"></i>
      </button>
      {/* Hanya untuk popup kalender; tidak terlihat dan tidak bisa di-tab. */}
      <input
        ref={pickerRef}
        type="date"
        tabIndex={-1}
        aria-hidden="true"
        value={dmyToIso(text) || ""}
        min={min}
        max={max}
        onChange={handlePick}
        style={{
          position: "absolute",
          bottom: 0,
          right: 0,
          width: "1px",
          height: "1px",
          opacity: 0,
          pointerEvents: "none",
          border: 0,
          padding: 0,
        }}
      />
    </div>
  );
};

export default DateInput;
